var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.625V17.5C17.5 18.163 17.2366 18.7989 16.7678 19.2678C16.2989 19.7366 15.663 20 15 20H5C4.33696 20 3.70107 19.7366 3.23223 19.2678C2.76339 18.7989 2.5 18.163 2.5 17.5V2.5C2.5 1.83696 2.76339 1.20107 3.23223 0.732233C3.70107 0.263392 4.33696 0 5 0L11.875 0L17.5 5.625ZM13.75 5.625C13.2527 5.625 12.7758 5.42746 12.4242 5.07583C12.0725 4.72419 11.875 4.24728 11.875 3.75V1.25H5C4.66848 1.25 4.35054 1.3817 4.11612 1.61612C3.8817 1.85054 3.75 2.16848 3.75 2.5V17.5C3.75 17.8315 3.8817 18.1495 4.11612 18.3839C4.35054 18.6183 4.66848 18.75 5 18.75H15C15.3315 18.75 15.6495 18.6183 15.8839 18.3839C16.1183 18.1495 16.25 17.8315 16.25 17.5V5.625H13.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.125C5 7.95924 5.06585 7.80027 5.18306 7.68306C5.30027 7.56585 5.45924 7.5 5.625 7.5H14.375C14.5408 7.5 14.6997 7.56585 14.8169 7.68306C14.9342 7.80027 15 7.95924 15 8.125V16.875C15 17.0408 14.9342 17.1997 14.8169 17.3169C14.6997 17.4342 14.5408 17.5 14.375 17.5H5.625C5.45924 17.5 5.30027 17.4342 5.18306 17.3169C5.06585 17.1997 5 17.0408 5 16.875V8.125ZM5 4.375C5 4.20924 5.06585 4.05027 5.18306 3.93306C5.30027 3.81585 5.45924 3.75 5.625 3.75H8.75C8.91576 3.75 9.07473 3.81585 9.19194 3.93306C9.30915 4.05027 9.375 4.20924 9.375 4.375C9.375 4.54076 9.30915 4.69973 9.19194 4.81694C9.07473 4.93415 8.91576 5 8.75 5H5.625C5.45924 5 5.30027 4.93415 5.18306 4.81694C5.06585 4.69973 5 4.54076 5 4.375Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.b713f47a.svg";
export { ForwardRef as ReactComponent };